<template>
  <v-dialog :value="value" @input="handleDialogInput" width="500">
    <v-card>
      <v-card-title class="headline grey lighten-2">
        {{ routemap.name }} {{ routemap.quantity }} {{ $t("COUNT_ABBREVIATION") }}
      </v-card-title>

      <v-card-text>
        <ErrorMessages :errorMessages="localErrorMessages" />

        {{ $t("COMMENT") }} (BG):
        <textarea v-model="comment" class="form-control"></textarea>
        <br />
        {{ $t("COMMENT") }} (EN):
        <textarea v-model="commentEn" class="form-control"></textarea>
        <br />
        <v-col class="12">
          <input
            v-model="needCleaning"
            type="checkbox"
            class="form-control dl-inline"
          />
          {{ $t("MARK_HERE_IF_NEEDED_FOR_CLEANING") }}
        </v-col>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text>
          <span class="btn btn-danger btn-block" @click="handlePauseClicked">
            {{ $t("PAUSE") }}
          </span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ErrorMessages from "@/components/ErrorMessages";

export default {
  components: {
    ErrorMessages
  },

  props: {
    routemap: {
      required: true,
      type: Object
    },

    value: {
      required: true,
      type: Boolean
    },

    errorMessages: {
      default: () => {}
    }
  },

  data() {
    return {
      comment: "",
      commentEn: "",
      needCleaning: false,
      localErrorMessages: {}
    };
  },

  watch: {
    value() {
      this.comment = "";
      this.commentEn = "";
      this.needCleaning = false;
      this.localErrorMessages = {};
    },

    errorMessages() {
      this.localErrorMessages = this.errorMessages;
    }
  },

  methods: {
    handlePauseClicked() {
      if (!this.comment || !this.commentEn) {
        this.localErrorMessages = {
          0: [this.$t("THE_FIELD_COMMENT_IS_REQUIRED")]
        };

        return;
      }

      this.$emit("pause-clicked", {
        comment: this.comment,
        commentEn: this.commentEn,
        needCleaning: this.needCleaning
      });
    },

    handleDialogInput(value) {
      this.comment = "";
      this.commentEn = "";
      this.needCleaning = false;
      this.localErrorMessages = {};

      this.$emit("input", value);
    }
  }
};
</script>
